import { render, staticRenderFns } from "./ReinstatementList.vue?vue&type=template&id=4f03f66e"
import script from "./ReinstatementList.vue?vue&type=script&lang=js"
export * from "./ReinstatementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports